import React, { useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { FlexColumn, MedBGContainer } from '../styles/Containers'
import BodyText from '../styles/Text'
import FileList from '../files/FileList'
import UploadFile from '../files/UploadFile'

export default function FinalDocuments({ requestType, requestId, fileList, editable, updateFileList, onFilesChanged = () => {} }) {
  const [errorFileNames, setErrorFileNames] = useState([])
  const [loading, setLoading] = useState(false)

  function postFileUpload({ id, file, type }) {
    const formData = new FormData()
    formData.append('file', file)

    const config = { headers: { 'Content-Type': 'multipart/form-data' } }

    if (type === 'foi') {
      formData.append('associationId', id)
      formData.append('associationType', type.toUpperCase())
      formData.append('usage', 'RESPONSE')
      return axios.post(`/file`, formData, config)
    }

    return axios.post(`/upload/${id}`, formData, config)
  }

  async function handleUpload(acceptedFiles) {
    if (!editable) return

    const files = Array.from(acceptedFiles || [])
    if (!files.length) return

    setErrorFileNames([])
    setLoading(true)

    let nextList = fileList
    const failed = []

    for (const file of files) {
      try {
        const response = await postFileUpload({ id: requestId, file, type: requestType })
        const { data } = response

        const formatted = {
          ...(requestType === 'pir'
            ? { name: file.name, etag: data.etag }
            : { id: data.data.id, filename: file.name, usage: file.usage || 'RESPONSE' }),
          size: file.size,
          lastModified: new Date().toISOString()
        }
        const key = requestType === 'pir' ? 'name' : 'filename'
        nextList = (Array.isArray(nextList) ? nextList : []).filter(f => f[key] !== file.name).concat([formatted])
      } catch (error) {
        const fileName = file.filename ? file.filename : file.name
        failed.push(fileName)
        console.error(`failed to upload the file %s for %s with ID %s`, fileName, requestType, requestId, error)
      }
    }

    updateFileList(nextList)
    setErrorFileNames(failed)
    setLoading(false)
    if (requestType === 'foi' && failed.length < files.length) onFilesChanged()
  }

  function handleDelete(fileIdentifier) {
    const newFileList = (Array.isArray(fileList) ? fileList : []).filter(f =>
      requestType === 'pir' ? f.name !== fileIdentifier : f.id !== fileIdentifier
    )
    updateFileList(newFileList)
    if (requestType === 'foi') onFilesChanged()
  }

  return (
    <FlexColumn gap="10px">
      <MedBGContainer padding="20px 30px 15px 15px">
        <FileList
          type={requestType === 'pir' ? 'pir' : 'database'}
          files={fileList}
          requestId={requestId}
          onDelete={editable ? handleDelete : undefined}
          buttonAction={editable ? 'delete' : 'download'}
        />
      </MedBGContainer>

      {editable && (
        <FlexColumn gap="12px">
          <BodyText>Drag and drop or browse below to add any additional files to the list:</BodyText>
          <UploadFile onUpload={handleUpload} errorFileNames={errorFileNames} loading={loading} />
        </FlexColumn>
      )}
    </FlexColumn>
  )
}

FinalDocuments.propTypes = {
  requestType: PropTypes.oneOf(['pir', 'foi']).isRequired,
  requestId: PropTypes.string.isRequired,
  fileList: PropTypes.array.isRequired,
  editable: PropTypes.bool.isRequired,
  updateFileList: PropTypes.func.isRequired,
  onFilesChanged: PropTypes.func
}
